export default "__VITE_ASSET__yFN92fa5__"